import { ConfigField, Field } from 'types/models/Forms';

export const isWebOrderingConfig = (
  field: ConfigField | Field,
): field is ConfigField => {
  return (field as ConfigField).fields !== undefined;
};
